/* eslint-disable prefer-destructuring */
// eslint-disable-next-line no-magic-numbers
export const ZOOM_LEVELS = [0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 4, 5] as const;
export const ZOOM_LEVEL_DEFAULT = 1;
export const ZOOM_LEVEL_MIN = ZOOM_LEVELS[0];
export const ZOOM_LEVEL_MAX = ZOOM_LEVELS[ZOOM_LEVELS.length - 1];
